export function getPrecision(v: number | string): number {
  const valueString = String(v);
  return valueString.indexOf('.') >= 0
    ? valueString.length - valueString.indexOf('.') - 1
    : 0;
}

export const getDecimalCount = (value: number | string): number =>
  getPrecision(value);
